import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stsFlagMapping'
})
export class StsFlagMappingPipe implements PipeTransform {

  transform(value: any): any {
    console.log(value);
    return (value && (value === 'Y' || value === 'ZSTS')) ? 'N' : 'Y';
  }

}
